// extracted by mini-css-extract-plugin
export default {"link":"Helptext_link__dikcQ"};